import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import styles from './ExamResults.module.css';
import apiClient from '../../../api/client';

const ExamResults = () => {
  const navigate = useNavigate();
  const { examId } = useParams();

  const [exam, setExam] = useState(null);
  const [results, setResults] = useState([]); // مجمعة لكل طالب: { student, paper, online }
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadData = async () => {
      try {
        const [examRes, gradesRes] = await Promise.all([
          apiClient.get(`/exams/${examId}`),
          apiClient.get(`/grades?exam=${examId}`),
        ]);
        setExam(examRes.data);

        // بنجمع درجات الورقي والأونلاين لكل طالب في صف واحد
        const byStudent = {};
        gradesRes.data.forEach((grade) => {
          if (!grade.student) return;
          const sid = grade.student._id;
          if (!byStudent[sid]) {
            byStudent[sid] = { student: grade.student, paper: null, online: null };
          }
          byStudent[sid][grade.type || 'online'] = grade.score;
        });
        setResults(Object.values(byStudent));
      } catch (error) {
        console.error('❌ مشكلة في جلب النتائج:', error);
      } finally {
        setLoading(false);
      }
    };
    loadData();
  }, [examId]);

  // دالة إرسال رسالة الواتساب - بتبعت درجة الورقي والأونلاين (اللي موجود منهم)
  const sendWhatsApp = (row) => {
    const student = row.student;
    const maxScore = exam?.maxScore || 100;
    const subject = exam?.subject || exam?.name || '';

    const scoreLines = [];
    if (row.paper !== null && row.paper !== undefined) {
      scoreLines.push(`📊 درجة الامتحان الورقي: ${row.paper} من ${maxScore}`);
    }
    if (row.online !== null && row.online !== undefined) {
      scoreLines.push(`📊 درجة الامتحان الأونلاين: ${row.online} من ${maxScore}`);
    }
    if (scoreLines.length === 0) {
      scoreLines.push(`📊 الدرجة: -- من ${maxScore}`);
    }

    const message =
`📚 سلسلة الأزهري في العلوم الشرعية
من معلمي المواد الشرعية:
أ/ حسام صبري الأزهري
أ/ محمد كامل الشيمي
إلى السيد/ ولي أمر الطالب: ${student?.name || ''}
السلام عليكم ورحمة الله وبركاته.
يسرنا أن نحيط سيادتكم علمًا بنتيجة نجلكم/ابنتكم في الامتحان الشهري لمادة (${subject})، وقد حصل على:
${scoreLines.join('\n')}
ونسأل الله أن يوفقه إلى كل خير، ونؤكد أن هذه المتابعة تأتي في إطار حرصنا على التواصل المستمر مع أولياء الأمور؛ إيمانًا بأن التعاون بين الأسرة والمعلم هو السبيل الأمثل لبناء طالبٍ متفوقٍ علمًا وخُلُقًا.
مع خالص الشكر والتقدير،
سلسلة الأزهري في العلوم الشرعية`;

    const phone = (student?.parentPhone || '').replace(/^0/, '20'); // تحويل الرقم المصري لصيغة دولية لواتساب
    const whatsappUrl = `https://wa.me/${phone}?text=${encodeURIComponent(message)}`;
    window.open(whatsappUrl, '_blank');
  };

  if (loading) return <div style={{ padding: '2rem' }}>جاري تحميل النتائج...</div>;

  return (
    <div className={styles.pageWrapper}>
      <div className={styles.header}>
        <div className={styles.titleBox}>
          <h1 className={styles.title}>نتائج: {exam?.name || 'امتحان'}</h1>
          <span className={styles.subtitle}>{exam?.stage} - إجمالي الطلاب: {results.length}</span>
        </div>
        <button className={styles.backBtn} onClick={() => navigate('/exams')}>
          رجوع للامتحانات
        </button>
      </div>

      <div className={styles.tableContainer}>
        <table className={styles.table}>
          <thead>
            <tr>
              <th>كود الطالب</th>
              <th>الاسم</th>
              <th>درجة الورقي</th>
              <th>درجة الأونلاين</th>
              <th>الحالة</th>
              <th>إبلاغ ولي الأمر</th>
            </tr>
          </thead>
          <tbody>
            {results.length > 0 ? results.map((row) => {
              const maxScore = exam?.maxScore || 100;
              const bestScore = row.online ?? row.paper;
              const isPass = bestScore !== null && bestScore !== undefined ? bestScore >= maxScore / 2 : null;
              return (
                <tr key={row.student._id}>
                  <td>{row.student?.code}</td>
                  <td>{row.student?.name}</td>
                  <td>{row.paper !== null && row.paper !== undefined ? `${row.paper} / ${maxScore}` : '—'}</td>
                  <td>{row.online !== null && row.online !== undefined ? `${row.online} / ${maxScore}` : '—'}</td>
                  <td>
                    {isPass !== null ? (
                      <span className={`${styles.scoreBadge} ${isPass ? styles.pass : styles.fail}`}>
                        {isPass ? 'ناجح' : 'راسب'}
                      </span>
                    ) : '—'}
                  </td>
                  <td>
                    <button
                      className={styles.whatsappBtn}
                      onClick={() => sendWhatsApp(row)}
                    >
                      💬 إرسال واتساب
                    </button>
                  </td>
                </tr>
              );
            }) : (
              <tr>
                <td colSpan="6" style={{ textAlign: 'center', color: '#6b7280' }}>
                  لسه محدش سلّم في الامتحان ده
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default ExamResults;
